const ITEMS = [
  "Sonorisation",
  "Éclairage",
  "Régie technique",
  "Infrastructures scéniques",
  "Scénographie & fabrication",
  "Fréjus — Var — PACA",
];

export const Marquee = () => (
  <div
    className="marquee overflow-hidden border-y border-line py-6 sm:py-8"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="marquee-track items-center gap-10 pr-10 sm:gap-16 sm:pr-16">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10 sm:gap-16">
          <span className="whitespace-nowrap text-3xl font-extrabold uppercase tracking-tight text-surface sm:text-5xl">
            {item}
          </span>
          <span className="h-2 w-2 shrink-0 bg-line" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
